import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { CONFIRM_BOOKING } from 'store/mutations';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';

const ConfirmBookingMutation = ({ update, children, revertChange, errRedirectUrl }) => {
  const [confirmBooking, { loading, error }] = useMutation(CONFIRM_BOOKING, {
    update
  });

  if (error) {
    if (revertChange) {
      revertChange();
    }

    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: errRedirectUrl
    });
  }

  return children({ confirmBooking, loading });
};

ConfirmBookingMutation.propTypes = {
  children: PropTypes.func,
  revertChange: PropTypes.func,
  update: PropTypes.func,
  errRedirectUrl: PropTypes.string
};

export default ConfirmBookingMutation;
